var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook2",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 100,
    cy: 100,
    r: 95,
    stroke: "#727273",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M 49.1221 55.0757L 49.1221 35.0482C 49.1221 29.5206 53.5235 25.0344 58.9465 25.0344L 68.771 25.0344L 68.771 0L 49.1221 0C 32.843 0 19.6488 13.4485 19.6488 30.0413L 19.6488 55.0757L 0 55.0757L 0 80.1101L 19.6488 80.1101L 19.6488 160.22L 49.1221 160.22L 49.1221 80.1101L 68.771 80.1101L 78.5954 55.0757L 49.1221 55.0757Z",
    transform: "translate(61 31)",
    fill: "#727273"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#727273"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBw);
export default __webpack_public_path__ + "static/media/facebook-bw.6ea06b7fb6d968eebb2325971dca7398.svg";
export { ForwardRef as ReactComponent };